<template>
  <div class="video-speeder-controls">
    <div class="row-1">
      <div class="col-1">
        <div
          class="swap-btn"
          @click="onSwap"
        >
          替换视频
        </div>
      </div>
      <div class="col-2">
        <div
          class="play-btn"
          @click="togglePlay"
        >
          <iconfont
            v-if="$parent.isPaused"
            name="#icon11-11zantingbofanganniu"
            font-size="16px"
          ></iconfont>
          <iconfont
            v-else
            name="#icon11-12bofanganniu"
            font-size="16px"
          ></iconfont>
        </div>
        <div class="duration-info">
          {{ formatedTiming }}/{{ formatedDuration }}
        </div>
      </div>
      <div class="col-3">
        <vol
          :value="vol"
          @input="updateVol"
        ></vol>
        <clear-watermark
          v-model="watermark.clearWatermark"
          class="watermark"
        ></clear-watermark>
      </div>
    </div>
    <div class="row-2">
      <time-range
        v-model="unit.timing"
        :min="0"
        :max="duration * 10"
        :step="0"
        @startMove="stopPlay"
      ></time-range>
    </div>
    <div class="row-3">
      <div>视频速率</div>
      <ul class="radio-list">
        <li
          v-for="(item, key) in radioItems"
          :key="key"
          class="radio"
          :class="{ active: key === activeIndex }"
          @click="onClickRadio(item)"
        >
          <div class="icon"></div>
          <div class="text">
            {{ item.text }}
          </div>
        </li>
      </ul>
      <div
        class="process-btn"
        @click="onProcess"
      >
        开始处理
      </div>
    </div>
  </div>
</template>

<script>
import Vol from '@/components/videoSpeeder/vol';
import ClearWatermark from '@/components/common/clearWatermark';
import TimeRange from '@/components/videoSpeeder/range';
import CheckMultiLogin from '@/mixins/checkMultiLogin.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    Vol,
    ClearWatermark,
    TimeRange
  },
  mixins: [CheckMultiLogin],
  props: {
    vol: {
      type: Number,
      default: 1
    },
    playbackRate: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      duration: 0,
      timing: 0,
      //watermarkCleared: true,
      unit: {
        timing: 0,
        duration: 0
      },
      radioItems: [{ text: '0.5' }, { text: '0.75' }, { text: '1.0' }, { text: '1.25' }, { text: '1.5' }, { text: '2.0' }],
      activeLabel: '1.0'
    };
  },
  computed: {
    ...mapGetters(['loginStatus']),
    ...mapGetters({
      inputInfo: 'videoSpeeder/getInputInfo',
      completedFiles: 'videoSpeeder/getCompletedFiles',
      watermark: 'common/watermark'
    }),
    formatedDuration() {
      let { seconds, minutes } = this.formatTime(this.duration / this.playbackRate);
      return minutes + ':' + seconds;
    },
    formatedTiming() {
      let { seconds, minutes } = this.formatTime(this.timing / this.playbackRate);
      return minutes + ':' + seconds;
    },
    activeIndex() {
      let index = -1;
      this.radioItems.some((item, i) => {
        let isFound = this.activeLabel === item.text;
        if (isFound) {
          index = i;
        }
        return isFound;
      });
      return index;
    }
  },
  watch: {
    inputInfo() {
      this.updateDuration();
      this.updateTiming();
    },
    'unit.timing'(val) {
      this.$emit('updateTiming', val / 10);
    },
    playbackRate(val) {
      let str = (val || 0).toFixed(2);
      if (str[str.length - 1] === '0') {
        str = str.slice(0, -1);
      }
      this.activeLabel = str;
    }
  },
  created() {
    this.updateDuration();
    this.updateTiming();
    this.$bus.on('taskSuccess.videoSpeeder', this.onProcessComplete);
  },
  beforeDestroy() {
    this.$bus.off('taskSuccess.videoSpeeder', this.onProcessComplete);
  },
  methods: {
    ...mapActions({
      process: 'videoSpeeder/process',
      checkStatus: 'videoSpeeder/checkStatus'
    }),
    formatedDuration_() {
      let { seconds, minutes } = this.formatTime(this.duration);
      return minutes + ':' + seconds;
    },
    formatedTiming_() {
      let { seconds, minutes } = this.formatTime(this.timing);
      return minutes + ':' + seconds;
    },
    async updateDuration() {
      let url = this.$.handleAssetsUrl(this.inputInfo.filename);
      this.duration = await this.getDuration(url);
      this.unit.duration = this.duration * 10;
    },
    getDuration(url) {
      return new Promise((resolve) => {
        let video = document.createElement('video');
        video.addEventListener('loadedmetadata', function() {
          resolve(video.duration);
        });
        video.src = url;
      });
    },
    formatTime(sec) {
      let seconds = this.pad(Math.floor(sec % 60));
      let minutes = this.pad(Math.floor(sec / 60));
      return {
        seconds,
        minutes
      };
    },
    pad(val) {
      val = '' + val;
      while (val.length < 2) {
        val = '0' + val;
      }
      return val;
    },

    updateTiming(time) {
      if (time == null) {
        let videoEl = this.$parent.$refs.viewVideo || this.$parent.$el.querySelector('.view-area > video');
        time = videoEl.currentTime;
      }
      this.timing = time;
      this.unit.timing = time * 10;
    },

    onSwap() {
      this.stopPlay();
      let fileData = {};
      this.$modal.show('selectModal', {
        onFile: (file) => {
          fileData.name = file.name;
          fileData.duration = file.duration;
          fileData.size = file.size;
        },
        onUrl: (url) => {
          this.$store.commit('videoSpeeder/setInputInfo', {
            ...fileData,
            filename: url
          });
          this.$modal.hide('selectModal');
        },
        onInfo: (info) => {
          this.$store.commit('videoSpeeder/setInputInfo', {
            filename: info.url,
            name: info.title,
            duration: info.duration,
            size: info.size,
            fileType: info.fileType
          });
          this.$modal.hide('selectModal');
          this.$emit('swapInputFileDone');
        }
      });
    },
    togglePlay() {
      this.$emit('togglePlay');
    },
    updateVol(val) {
      this.$emit('updateVol', val);
    },
    stopPlay() {
      if (!this.$parent.isPaused) {
        this.togglePlay();
      }
    },
    onClickRadio(item) {
      this.activeLabel = item.text;
      this.$parent.updatePlaybackRate(item.text - 0);
    },
    async onProcess() {
      if (this.processing) {
        return;
      }
      this.processing = true;
      // this.$bus.emit('checkLogin');
      let checkResult = (await this.checkMultiLogin()) || {};

      if (!this.loginStatus || (checkResult && checkResult.type)) {
        this.storeRegisterSource('完成');
        this.processing = false;
        return;
      }

      let result = await this.process({
        speed: this.activeLabel - 0,
        nonwatermark: this.watermark.clearWatermark ? 1 : 0
      });
      if (result) {
        let video_source = '';
        if (this.inputInfo.fileType == 26) {
          video_source = '视频库';
        } else if (this.inputInfo.fileType == 27) {
          video_source = '作品库';
        } else {
          video_source = '本地上传';
        }
        this.$sensors.track('toolVideoProcess', {
          tool_type: '变速宝',
          video_source,
          video_duration: this.inputInfo.duration,
          video_size: this.inputInfo.size
        });
        this.$bus.emit('maskLayer', {
          show: true,
          type: 'videoSpeeder',
          info: {
            ...result,
            name: this.inputInfo.name,
            taskId: result.taskId,
            key: result.key,
            newkey: result.newkey
          }
        });
      } else {
        this.$message({
          message: '处理失败',
          type: 'error',
          center: true
        });
      }

      this.processing = false;
    },
    async onProcessComplete(info) {
      let nameParts = (this.inputInfo.name || '').split('.') || [];
      if (nameParts.length > 2) {
        let _part = nameParts.slice(0, -1).join('.');
        nameParts = [_part, 'mp4'];
      }
      let name = nameParts[0] + '-' + this.activeLabel + '倍速.' + (nameParts[1] || 'mp4');
      let url = this.$.handleAssetsUrl(info.newkey);
      let duration = await this.getDuration(url);
      let cover = this.inputInfo.cover || info.thumbnailkey;
      if (!cover) {
        cover = await this.getVideoThumbnail(url);
      }
      let file = {
        url: info.newkey,
        name,
        cover,
        duration
      };
      this.$store.commit('videoSpeeder/addFile', file);
      this.$bus.emit('autoComplete', file);
    },
    getVideoThumbnail(url) {
      return new Promise((resolve) => {
        let video = document.createElement('video');
        video.crossOrigin = 'anonymous';
        video.currentTime = 2;
        let crop = () => {
          let timer = setTimeout(() => {
            video.removeEventListener('loadeddata', crop);
            clearTimeout(timer);
            let canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            let ctx = canvas.getContext('2d');
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob) => {
              resolve(blob);
            });
          }, 0);
        };
        video.addEventListener('loadeddata', crop);
        video.setAttribute('src', url);
      }).catch((reason) => {
        console.log('catch:', reason);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.video-speeder-controls {
  padding-top: 32px;
}
.row-1 {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  & .col-2 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
  }
  & .col-3 {
    display: flex;
    align-items: center;
    min-width: 155px;
    transform: translatex(21px);
  }
}
.row-2 {
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
}
.row-3 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.swap-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 92px;
  height: 30px;
  background: #ffffff;
  border: 1px solid #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(124, 124, 124, 0.13);
  border-radius: 15px;
  cursor: pointer;
  &:hover {
    color: #2f58fe;
    border: 1px solid #2f58fe;
  }
}
.play-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  background: #ffffff;
  box-shadow: 0px 2px 5px 0px rgba(124, 124, 124, 0.13);
  border-radius: 50%;
  cursor: pointer;
  color: #2f58fe;
}
.duration-info {
  // position: absolute;
  // left: calc(100% + 18px);
  margin-left: 18px;
}
.watermark {
  margin-left: 30px;
}
@media only screen and (max-width: 1327px) {
  .watermark {
    margin-left: 4px;
  }
}
.radio-list {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 40px;
}
.radio {
  display: flex;
  margin-left: 20px;
  cursor: pointer;
  & .icon {
    width: 14.6px;
    height: 14.6px;
    border-radius: 14px;
    border: solid 1.6px #919192;
  }
  & .text {
    margin-left: 6px;
  }
}
.radio.active {
  & .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2f58fe;
    border-color: #2f58fe;
    &:before {
      box-sizing: border-box;
      flex-shrink: 0;
      flex-grow: 0;
      content: ' ';
      width: 100%;
      height: 100%;
      border-radius: 13px;
      border: solid 1.6px #fff;
      background: #2f58fe;
    }
  }
}
.process-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 40px;
  background: #2f58fe;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  &:hover {
    background: #3d7dff;
  }
}
@media only screen and (max-width: 1600px) {
  .process-btn {
    width: 84px;
    height: 30px;
    font-size: 12px;
  }
  .play-btn {
    width: 36px;
    height: 36px;
    font-size: 12px !important;
    & > svg {
      font-size: 12px !important;
    }
  }
  .swap-btn {
    width: 80px;
    height: 26px;
    font-size: 12px;
  }
  .duration-info {
    font-size: 12px;
    margin-left: 10px;
  }
}
</style>
